export default "__VITE_ASSET__LHeir7Dm__"